import React from 'react';
export const Wallet: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.94"
      height="18.03"
      fill="currentColor"
      {...props}
    >
      <g fill="currentColor" stroke="currentColor" strokeWidth=".03">
        <path
          data-name="Path 21810"
          d="M4.038.61a1.374 1.374 0 00-.5 1.2v3.139h9.928a2.428 2.428 0 01.892.169l.062-.1a2.174 2.174 0 00-.61-.429L4.987.604a1.25 1.25 0 00-.509-.121.8.8 0 00-.442.127zM.478 9.274v4.059h3.76a1.987 1.987 0 001.985-1.985v-.088a1.987 1.987 0 00-1.985-1.985zm1.985-3.86A1.987 1.987 0 00.478 7.399v1.408h3.76A2.455 2.455 0 016.69 11.26v.088a2.455 2.455 0 01-2.452 2.453H.478v1.763a1.987 1.987 0 001.985 1.985h11a1.987 1.987 0 001.985-1.985V7.399a1.987 1.987 0 00-1.985-1.985zm0 12.6A2.455 2.455 0 01.01 15.562V7.397a2.455 2.455 0 012.453-2.453h.609V1.805a1.822 1.822 0 01.711-1.59 1.258 1.258 0 01.694-.2 1.712 1.712 0 01.7.163L14 4.163a3.731 3.731 0 011.917 3.235v8.165a2.455 2.455 0 01-2.453 2.452z"
        />
        <path
          data-name="Path 21814"
          d="M3.323 11.215a.964.964 0 10.964-.964.965.965 0 00-.964.964zm-.468 0a1.432 1.432 0 111.432 1.432 1.434 1.434 0 01-1.432-1.432z"
        />
      </g>
    </svg>
  );
};
